import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { nameregex, priceRegex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import JoditEditor from "jodit-react";
import { getpropertyType } from "../store/slices/propertyType";
import { getPlaceList } from "../store/slices/places";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { GrUploadOption } from "react-icons/gr";
import { getAmenityList } from "../store/slices/amenity";
import { editHotelDetails, gethotelList } from "../store/slices/hotel";

const EditHotel = () => {
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const editor = useRef(null);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [propertyType, setpropertyType] = useState("");
  const [starRating, setstarRating] = useState("");
  const [nearbyPlacesErros, setnearbyPlacesErros] = useState([]);
  const [locality, setLocality] = useState("");
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [standardPrice, setstandardPrice] = useState("");
  const [availableRooms, setavailableRooms] = useState("");
  const [checkinTime, setcheckinTime] = useState("");
  const [checkoutTime, setcheckoutTime] = useState("");
  const [images, setImages] = useState([]);
  const [imageError, setImageError] = useState("");
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [platformCharges, setplatformCharges] = useState();
  const [contact, setContact] = useState({
    name: "",
    email: "",
    mobile: "",
    website: "",
  });

  const [address, setAddress] = useState({
    address: "",
    zipCode: "",
    city: "",
    state: "",
  });
  const [bookingPolicy, setbookingPolicy] = useState("");
  const [propertytypeList, setpropertytypeList] = useState([]);
  const [placeList, setplaceList] = useState([]);
  const [amenityList, setamenityList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };

  const [nearbyPlaces, setnearbyPlaces] = useState([
    {
      id: Date.now(),
      name: "",
      description: "",
    },
  ]);

  useEffect(() => {
    const fetPropertyDetails = async () => {
      try {
        const data = await dispatch(gethotelList({ id })).unwrap();
        const hotelDatas = data?.hotelData[0];
        setAddress(hotelDatas.address);
        setName(hotelDatas.name);
        setpropertyType(hotelDatas.propertyType._id);
        setcheckinTime(hotelDatas.checkinTime);
        setcheckoutTime(hotelDatas.checkoutTime);
        setavailableRooms(hotelDatas.availableRooms);
        setstandardPrice(hotelDatas.standardPrice);
        setstarRating(hotelDatas.starRating);
        setbookingPolicy(hotelDatas.bookingPolicy);
        setDescription(hotelDatas.description);
        setImages(hotelDatas.images);
        setLocality(hotelDatas.locality?._id || "");
        setContact(hotelDatas.contact);
        setplatformCharges(hotelDatas.platformCharges);
        const fetchedAmenities = hotelDatas?.amenities || [];
        setSelectedAmenities(fetchedAmenities.map((amenity) => amenity._id));
        setnearbyPlaces(hotelDatas.nearbyPlaces || []);
      } catch (error) {
        console.error("Error fetching package details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetPropertyDetails();
  }, [dispatch, id]);

  const handleAmenityChange = (amenityId) => {
    setSelectedAmenities((prev) => {
      if (prev.includes(amenityId)) {
        // Remove if already selected
        return prev.filter((id) => id !== amenityId);
      } else {
        // Add if not selected
        return [...prev, amenityId];
      }
    });
  };

  const validateAddressField = (field, value) => {
    switch (field) {
      case "address":
        return value.trim() === "" ? "Please enter address" : "";
      case "zipCode":
        return value === ""
          ? "Please enter pincode"
          : !/^\d{6}$/.test(value)
          ? "Please enter a valid pincode"
          : "";
      case "city":
        return value.trim() === "" ? "Please enter city name" : "";
      default:
        return "";
    }
  };

  const handleAddressChange = (field, value) => {
    setAddress((prevAddress) => ({
      ...prevAddress,
      [field]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      address: {
        ...prevErrors.address,
        [field]: validateAddressField(field, value),
      },
    }));
  };

  const validateContact = (field, value) => {
    switch (field) {
      case "name":
        return value.trim() === "" ? "Please enter contact person name" : "";
      case "email":
        return value.trim() === ""
          ? "Please enter email"
          : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? "Please enter a valid email"
          : "";
      case "mobile":
        return value.trim() === "" ? "Please enter contact number" : "";

      case "website":
        return value.trim() !== "" &&
          !/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-]*)?$/.test(value)
          ? "Please enetr a valid website url"
          : "";

      default:
        break;
    }
  };
  const handleContactChange = (field, value) => {
    setContact((prevContact) => ({
      ...prevContact,
      [field]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      contact: {
        ...prevErrors.contact,
        [field]: validateContact(field, value),
      },
    }));
  };

  const handleAddPlace = (e) => {
    e.preventDefault();

    setnearbyPlaces([
      ...nearbyPlaces,
      {
        id: Date.now(),
        name: "",
        description: "",
      },
    ]);

    setnearbyPlacesErros([
      ...nearbyPlacesErros,
      {
        name: "",
        description: "",
      },
    ]);
  };

  const handleRemovePlaces = (id) => {
    const updatedPlaces = nearbyPlaces.filter((q) => q.id !== id);
    setnearbyPlaces(updatedPlaces);

    const updatedErrors = nearbyPlacesErros.filter(
      (_, index) => nearbyPlaces[index].id !== id
    );
    setnearbyPlacesErros(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    const updatedPlaces = [...nearbyPlaces];
    updatedPlaces[index][field] = value;
    setnearbyPlaces(updatedPlaces);
    const updatedErrors = [...nearbyPlacesErros];
    if (!updatedErrors[index]) {
      updatedErrors[index] = { name: "", description: "" };
    }

    if (field === "name") {
      updatedErrors[index].name =
        value.trim() === "" ? "Please enter place name" : "";
    }
    if (field === "description") {
      updatedErrors[index].description =
        value.trim() === "" ? "Please enter place distance" : "";
    }

    setnearbyPlacesErros(updatedErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };
    let sanitizedcheckoutTime = standardPrice;
    let sanitizedavailableRooms = availableRooms;

    switch (name) {
      case "name":
        setName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter valid property name"
            : "";
        break;

      case "propertyType":
        setpropertyType(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select property type" : "";
        break;

      case "starRating":
        setstarRating(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select star rating" : "";
        break;

      case "checkinTime":
        setcheckinTime(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select checkin time" : "";
        break;

      case "checkoutTime":
        setcheckoutTime(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select checkout time" : "";
        break;

      case "locality":
        setLocality(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select locality" : "";
        break;

      case "standardPrice":
        sanitizedcheckoutTime = value.replace(/\D/g, "").slice(0, 6);
        setstandardPrice(sanitizedcheckoutTime);
        validationErrors[name] =
          sanitizedcheckoutTime === "" ||
          !priceRegex.test(sanitizedcheckoutTime)
            ? "Please enter valid price"
            : "";
        break;

      case "platformCharges":
        let sanitizedValue = value.replace(/[^0-9.]/g, "");
        const parts = sanitizedValue.split(".");
        if (parts.length > 2) {
          sanitizedValue = parts[0] + "." + parts.slice(1).join(""); // Keep only the first decimal point
        }

        const match = sanitizedValue.match(/^\d{0,2}(\.\d{0,2})?$/);
        if (match) {
          setplatformCharges(sanitizedValue); // Only update state if the format is valid
        }
        break;

      case "availableRooms":
        sanitizedavailableRooms = value.replace(/\D/g, "").slice(0, 3);
        setavailableRooms(sanitizedavailableRooms);
        validationErrors[name] =
          sanitizedavailableRooms === "" ||
          !priceRegex.test(sanitizedavailableRooms)
            ? "Please enter valid value"
            : "";
        break;

      case "description":
        setDescription(value);
        if (errors.description && stripHtmlTags(value).length > 0) {
          setErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        }
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    setErrors(validationErrors);
  };

  const scrollToError = () => {
    const firstErrorField = document.querySelector(".is-invalid");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstErrorField.focus();
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!name?.trim()) {
      newErrors.name = "Please enter property name";
    } else if (!nameregex.test(name)) {
      newErrors.name = "Please enter valid property name";
    }
    if (!starRating) {
      newErrors.starRating = "Please select a star rating";
    }

    if (!propertyType) {
      newErrors.propertyType = "Please select property type";
    }

    if (selectedAmenities.length === 0) {
      newErrors.amenities = "Please select at least one amenity";
    }
    if (!locality) {
      newErrors.locality = "Please select locality";
    }

    if (!standardPrice?.trim()) {
      newErrors.standardPrice = "Please enter standard price";
    } else if (!priceRegex.test(standardPrice)) {
      newErrors.standardPrice = "Please enter valid price";
    }

    if (!availableRooms) {
      newErrors.availableRooms = "Please enter available rooms";
    } else if (!priceRegex.test(availableRooms)) {
      newErrors.availableRooms = "Please enter valid value";
    }

    if (!platformCharges) {
      newErrors.platformCharges = "Please enter platform charges";
    }

    if (!description?.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter valid description";
    }

    if (!bookingPolicy?.trim() || stripHtmlTags(bookingPolicy).length === 0) {
      newErrors.bookingPolicy = "Please enter valid booking policy";
    }

    if (images.length === 0) {
      newErrors.image = "Please upload at least one image";
    }

    if (!checkinTime) {
      newErrors.checkinTime = "Please select checkin time";
    }

    if (!checkoutTime) {
      newErrors.checkoutTime = "Please select checkout time";
    }

    const nearbyPlacesErrors = nearbyPlaces.map((place, index) => {
      console.log(`Validating nearby place #${index}:`, place);
      return {
        name: place?.name?.trim() ? "" : "Please enter place name",
        description: place?.description?.trim()
          ? ""
          : "Please enter place distance",
      };
    });

    setnearbyPlacesErros(nearbyPlacesErrors);

    if (nearbyPlacesErros.some((err) => err.title || err.description)) {
      newErrors.nearbyPlaces = "Please fix errors in the nearby place section";
    }
    console.log("Validation errors:", newErrors, nearbyPlacesErrors);
    setErrors(newErrors);
    const isValid =
      Object.keys(newErrors).length === 0 &&
      nearbyPlacesErros.every((err) => !err.title && !err.description);

    // If form is invalid, scroll to the first error
    if (!isValid) {
      scrollToError();
    }

    return isValid;
  };
  const addPackage = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    setTimeout(() => setIsDisabled(false), 3000);

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.");
      setIsDisabled(false);
      return;
    }

    const item = {
      propertyType,
      name,
      starRating,
      standardPrice,
      availableRooms,
      isActive: 1,
      isApproved: 1,
      checkinTime,
      checkoutTime,
      amenities: selectedAmenities,
      contact,
      address,
      locality,
      nearbyPlaces,
      bookingPolicy,
      images: images,
      description,
      platformCharges,
      id,
    };

    try {
      await dispatch(editHotelDetails(item)).unwrap();
      alert("Property edited successfully!");
      navigate(-1);
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (images.length + files.length > 15) {
      setImageError("You can upload a maximum 15 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image"
        );
        return;
      }
    }

    setImages((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  useEffect(() => {
    console.log("Updated images state:", images);
  }, [images]);

  const removeImage = (index) => {
    setImages((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Start typing...",
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    []
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const propertyData = await dispatch(getpropertyType()).unwrap();
        setpropertytypeList(propertyData || []);

        const placeData = await dispatch(getPlaceList()).unwrap();
        setplaceList(placeData || []);

        const amenityDatas = await dispatch(getAmenityList()).unwrap();
        setamenityList(amenityDatas?.amenityData || []);
      } catch (err) {
        console.error("Error fetching data:", err.message);
      }
    };
    fetchData();
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Edit Property</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              onClick={cancel}
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Property
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Edit Property</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Property Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  maxLength={150}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Property Name"
                />
                {errors.name && (
                  <div className="text-danger mt-2">{errors.name}</div>
                )}
              </div>
              <div className="col-md-5">
                <label className="form-label">
                  Property Type <span className="text-danger">*</span>
                </label>
                <select
                  name="propertyType"
                  value={propertyType}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.propertyType ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  {propertytypeList?.propertyTypeData?.map((catdata) => (
                    <option key={catdata._id} value={catdata._id}>
                      {catdata.name}
                    </option>
                  ))}
                </select>
                {errors.propertyType && (
                  <div className="text-danger mt-2">{errors.propertyType}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Standard Price <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="standardPrice"
                  value={standardPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.standardPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Standard Price"
                />
                {errors.standardPrice && (
                  <div className="text-danger mt-2">{errors.standardPrice}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Available Rooms
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="availableRooms"
                  value={availableRooms}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.availableRooms ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Available Rooms"
                />
                {errors.availableRooms && (
                  <div className="text-danger mt-2">
                    {errors.availableRooms}
                  </div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Checkin Time <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  name="checkinTime"
                  value={checkinTime}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.checkinTime ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Odd Person Percent"
                />
                {errors.checkinTime && (
                  <div className="text-danger mt-2">{errors.checkinTime}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Checkout Time <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  name="checkoutTime"
                  value={checkoutTime}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.checkoutTime ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Single Pax Price"
                />
                {errors.checkoutTime && (
                  <div className="text-danger mt-2">{errors.checkoutTime}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Locality<span className="text-danger">*</span>
                </label>
                <select
                  name="locality"
                  value={locality}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.locality ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  {placeList?.placesData?.map((placedata) => (
                    <option key={placedata._id} value={placedata._id}>
                      {placedata.name}
                    </option>
                  ))}
                </select>

                {errors.locality && (
                  <div className="text-danger mt-2">{errors.locality}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Star Rating<span className="text-danger">*</span>
                </label>
                <select
                  name="starRating"
                  value={starRating}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.starRating ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  <option value="No Rating">No Rating</option>
                  <option value="2 Star">2 Star</option>
                  <option value="3 Star">3 Star</option>
                  <option value="4 Star">4 Star</option>
                  <option value="5 Star">5 Star</option>
                </select>

                {errors.starRating && (
                  <div className="text-danger mt-2">{errors.starRating}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Platform Charges<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="platformCharges"
                  value={platformCharges}
                  onChange={handleChange}
                  placeholder="Enter platform charges"
                  className={`form-control ${
                    errors.platformCharges ? "is-invalid" : ""
                  }`}
                />

                {errors.platformCharges && (
                  <div className="text-danger mt-2">
                    {errors.platformCharges}
                  </div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label for="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {images.map((img, index) => (
                    <div
                      className="col-md-2 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  onChange={(newContent) => {
                    setDescription(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      description:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid description"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Select Amenities <span className="text-danger">*</span>
                </label>
                <div
                  className="border p-3 d-flex flex-wrap gap-3"
                  style={{ borderRadius: "5px" }}
                >
                  {amenityList.map((amenity) => (
                    <div key={amenity._id} className="form-check">
                      <input
                        type="checkbox"
                        style={{ marginTop: "4px" }}
                        id={`amenity-${amenity._id}`}
                        value={amenity._id}
                        checked={selectedAmenities.includes(amenity._id)}
                        onChange={() => handleAmenityChange(amenity._id)}
                        className="form-check-input"
                      />
                      &nbsp;
                      <label
                        htmlFor={`amenity-${amenity._id}`}
                        className="form-check-label"
                      >
                        {amenity.name}
                      </label>
                    </div>
                  ))}
                </div>
                {errors.amenities && (
                  <div className="text-danger mt-2">{errors.amenities}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Nearby Places <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {nearbyPlaces.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddPlace}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemovePlaces(item.id)}
                          disabled={nearbyPlaces.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label className="form-label">
                            Place Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Place Name"
                            value={item.name}
                            onChange={(e) =>
                              handleInputChange(index, "name", e.target.value)
                            }
                            className="form-control"
                          />
                          {nearbyPlacesErros[index]?.name && (
                            <span className="error-message">
                              {nearbyPlacesErros[index]?.name}
                            </span>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">
                            Place Distance
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Place Distance"
                            value={item.description}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "description",
                                e.target.value
                              )
                            }
                            className="form-control"
                          />
                          {nearbyPlacesErros[index]?.description && (
                            <span className="error-message">
                              {nearbyPlacesErros[index]?.description}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Address <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  <div className="container border p-3 mb-3 rounded">
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <label className="form-label">
                          Address<span className="text-danger">*</span>
                        </label>
                        <textarea
                          placeholder="Enter address"
                          value={address?.address}
                          onChange={(e) =>
                            handleAddressChange("address", e.target.value)
                          }
                          className={`form-control ${
                            errors?.address?.address ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.address?.address && (
                          <div className="text-danger">
                            {errors.address.address}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mt-3">
                        <label className="form-label">
                          Pincode <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          placeholder="Enter pincode"
                          value={address?.zipCode}
                          onChange={(e) =>
                            handleAddressChange("zipCode", e.target.value)
                          }
                          className={`form-control ${
                            errors?.address?.zipCode ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.address?.zipCode && (
                          <div className="text-danger">
                            {errors.address.zipCode}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label">
                          City<span className="text-danger">*</span>
                        </label>
                        <select
                          name="locality"
                          value={address?.city}
                          onChange={(e) =>
                            handleAddressChange("city", e.target.value)
                          }
                          className={`form-control ${
                            errors?.address?.city ? "is-invalid" : ""
                          }`}
                        >
                          <option value="">Select</option>
                          {placeList?.placesData?.map((placedata) => (
                            <option key={placedata._id} value={placedata._id}>
                              {placedata.name}
                            </option>
                          ))}
                        </select>

                        {errors?.address?.city && (
                          <div className="text-danger">
                            {errors.address.city}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Contact Details <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  <div className="container border p-3 mb-3 rounded">
                    <div className="row mt-3">
                      {/* Name */}
                      <div className="col-md-6">
                        <label className="form-label">
                          Contact Person Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter contact person name"
                          value={contact.name}
                          onChange={(e) =>
                            handleContactChange("name", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.name ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.name && (
                          <div className="text-danger">
                            {errors.contact.name}
                          </div>
                        )}
                      </div>

                      {/* Email */}
                      <div className="col-md-6">
                        <label className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          placeholder="Enter email"
                          value={contact.email}
                          onChange={(e) =>
                            handleContactChange("email", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.email ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.email && (
                          <div className="text-danger">
                            {errors.contact.email}
                          </div>
                        )}
                      </div>

                      {/* Mobile */}
                      <div className="col-md-6 mt-3">
                        <label className="form-label">
                          Contact Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter contact number"
                          value={contact.mobile}
                          onChange={(e) =>
                            handleContactChange("mobile", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.mobile ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.mobile && (
                          <div className="text-danger">
                            {errors.contact.mobile}
                          </div>
                        )}
                      </div>

                      {/* Website */}
                      <div className="col-md-6 mt-3">
                        <label className="form-label">Website</label>
                        <input
                          type="text"
                          placeholder="Enter website"
                          value={contact.website}
                          onChange={(e) =>
                            handleContactChange("website", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.website ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.website && (
                          <div className="text-danger">
                            {errors.contact.website}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Booking Policy <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={bookingPolicy}
                  onChange={(newContent) => {
                    setbookingPolicy(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      bookingPolicy:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid booking policy"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.bookingPolicy && (
                  <div className="text-danger mt-2">{errors.bookingPolicy}</div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditHotel;
